<template lang="pug">
#generic-card.card.generic-card
  .d-flex.align-items-start.justify-content-between.gap-3
    .flex-grow-1
      .d-flex.align-items-center.gap-2.generic-card__header.mb-1
        icon.generic-card__icon(:name='iconName')
        h6.organization-owner-card__title.mb-0 {{ title }}
      .generic-card__meta-row
        p.generic-card__meta.mb-0
          | {{ message }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'GenericCard',
  components: {
    Icon,
  },
  props: {
    iconName: {
      type: String,
      required: false,
      default: 'user',
    },
    title: {
      type: String,
      required: true,
      default: '',
    },
    message: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="stylus">
.generic-card {
  text-align: left;
  border: 1px solid #cccccc;
  border-radius: 10px;
  padding: 16px;
  background: #ffffff;
}

.generic-card__header {
  color: #013D52;
}

.organization-owner-card__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: inherit;
}

.generic-card__icon {
  color: inherit;
  font-size: 18px;
  line-height: 1;
}

.generic-card__meta-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.generic-card__meta {
  margin: 0;
  font-size: 14px;
  color: #013D52;
}
</style>
